import Parcelas from "./Parcelas";

export default {
    PARCELAS : Parcelas.br,
}